module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/DO-86bba07a7fd8d4d760f43ee8d0ea5526.png";